export const LANGUAGE_NAME_TO_ABRV = {
  English: 'default',
  Español: 'es',
}
